<template>
      <div class="container">
                <div class="page-header">
                    <div class="page-title">

                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                 <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                               <li>
                                  <router-link :title="'الحضور والغياب'" :to="{name: 'absences'}"> الحضور والغياب</router-link>
                                </li>
                                 <li class="active">
                                  <router-link :title="'تعديل'" :to="{name: 'absences.edit', params: {id: data.form.id}}">تعديل</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>


                <div class="row">

                    <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12  layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>
                                           <i class="flaticon-computer-4"></i>
                                          بيانات الحضور والغياب</h4>

                                    </div>
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">
                                <form @submit.prevent="update()">
                                         <div class="row">
                                          
                                       <div class="col-md-4">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">المرحلة الدراسية</label>
                                            <treeselect :options="stages" v-model="data.form.stage_id" @select="getGroups" :multiple="false" />
                                            <div class="invalid-feedback" :style="getErrors['stage_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['stage_id']">
                                                  {{ getErrors['stage_id'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">الصف الدراسى</label>
                                           
                                            <treeselect :options="groups" v-model="data.form.group_id" @select="getLessons" :multiple="false" />

                                            <div class="invalid-feedback" :style="getErrors['group_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['group_id']">
                                                  {{ getErrors['group_id'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">الحلقة</label>
                                            <treeselect :options="lessons" :auto-load-root-options="true" v-model="data.form.lesson_id" @select="getTeachers" :multiple="false"/>
                                            <div class="invalid-feedback" :style="getErrors['lesson_id'] ? 'display: block' : 'display: none;'"   v-if="getErrors['lesson_id']">
                                                  {{ getErrors['lesson_id'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-12" v-if="user.role == 'admin'">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">المعلم</label>
                                            <treeselect :options="teachers" :auto-load-root-options="true" v-model="data.form.teacher_id" @select="getTeachers" :multiple="false"/>
                                            <div class="invalid-feedback" :style="getErrors['teacher_id'] ? 'display: block' : 'display: none;'"   v-if="getErrors['teacher_id']">
                                                  {{ getErrors['teacher_id'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                       <div :class="'col-md-' + (user.role == 'admin' ? '12' : '6')">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">التاريخ</label>
                                            <date-picker v-model="data.form.date_and_time" :editable="true" :calendar="'hijri'"></date-picker>
                                            <div class="invalid-feedback" :style="getErrors['date_and_time'] ? 'display: block' : 'display: none;'"  v-if="getErrors['date_and_time']">
                                                  {{ getErrors['date_and_time'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-12 table-responsive">
                                      <!-- <a href="#" @click.prevent="addStudent" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-plus">إضافة طالب </a> -->

                                        <table class="table table-bordered">
                                          <thead>
                                            <tr>

                                              <th>الطالب</th>
                                              <th>الحالة</th>
                                              <!-- <th>#</th> -->
                                            </tr>
                                          </thead>

                                          <tbody>
                                            <tr v-for="(st, k) in data.form.students" :key="k">

                                              <td v-if="data.form.students[k]">
                                                <h6>{{data.form.students[k].student_name}}</h6>
                                                <div class="invalid-feedback" :style="getErrors['students.'+k+'.student_id'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.student_id']">
                                                      {{ getErrors['students.'+k+'.student_id'][0] }}
                                                </div>
                                              </td>
                                              <td v-if="data.form.students[k]">
                                                <input type="radio" v-model="data.form.students[k].type" value="presence"> حضور
                                                <input type="radio" v-model="data.form.students[k].type" value="absence"> غياب
                                                <input type="radio" v-model="data.form.students[k].type" value="delay"> تأخير
                                                <input type="radio" v-model="data.form.students[k].type" value="excuse"> استأذان
                                                 <div class="invalid-feedback" :style="getErrors['students.'+k+'.type'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.type']">
                                                      {{ getErrors['students.'+k+'.type'][0] }}
                                                </div>
                                              </td>
<!--                                               
                                              <td>
                                                <a href="#" class="btn btn-danger" v-if="k != 0" @click.prevent="deleteFromStudent(st)">X</a>
                                              </td> -->
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>


                                    <button type="submit" class="save-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>حفظ</span></button>
                                    <button type="button" @click.prevent="resetForm" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>تفريغ</span></button>
                                    <router-link class="back-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p" :to="{name: 'absences'}">
                                      <span>رجوع</span>
                                    </router-link>
                              </form>
                            </div>
                        </div>
                    </div>

                </div>


            </div>
</template>
<script>
import router from '@/router'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import VueDatetimeJs from 'vue-datetime-js'

export default {
  components: {
    Treeselect,
    datePicker: VueDatetimeJs,

  },
  data() {
    return {
      isExist: 0,
      trans: {},
      data: {
        checkerExit: 0,
        form: {
          teacher_id: '',
          lesson_id: '',
          group_id: '',
          stage_id: '',
          date_and_time: '',
          students: [{

          student_id: '',
          student_name: '',
          stOptions: [],
          type: 'presence',
          }],
        },
        permissions: [],
        isRequested: false,
        errors: {},
        paginated: {},
        allSelected: false,
      },
      isChanged: 0,
      teachers: [],
      lessons: [],
      stages: [],
      groups: [],
      sura: []
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    resetForm(){
      this.data.form = {
          teacher_id: '',
          lesson_id: '',
          group_id: '',
          stage_id: '',
          date_and_time: '',
          students: [{

          student_id: '',
          student: '',
          stOptions: [],
          type: 'presence',
          }],
        };
    },
    checkerExit(){
        this.$baseApi.get('/absences/absences/' + this.$route.params.id + '/edit?option=checker&lesson='+this.data.form.lesson_id + '&date=' + this.data.form.date_and_time).then((response)=>{
            if(response.data.code == 200){
               this.isExist = 0;
            }
        }).catch((error) => {
          this.isExist = 1;
          this.sweetAlert(error.response.data.errors[0], 'error');
        });
      },
    getInfo() {
      this.$baseApi.get('/absences/absences/' + this.$route.params.id + '/edit').then((response) => {
        if (response.data.code == 200 && response.data.data != null) {
          this.data.form        = response.data.data.absence;
          this.teachers            = response.data.data.teachers;
          this.stages            = response.data.data.stages;
          this.groups            = response.data.data.groups;
          this.lessons            = response.data.data.lessons;
          if(this.user.role == 'teacher'){
            this.data.form.teacher_id = this.user.teacher_id;
          }
        } else if (response.data.code == 404) {
          router.push('/absences');
        } else {
          alert(response.data.data.error);
          router.push('/absences');
        }
      });
    },
    update() {
      if(this.isExist){
        this.sweetAlert('من فضلك تأكد من البيانات وحاول مرة اخرى', 'error');
        return;
      }
      this.data.isRequested = true;
      this.$baseApi.patch('/absences/absences/' + this.data.form.id, this.data.form).then((response) => {
        if (response.data.code === 200) {
          localStorage.setItem('flash_message', response.data.messages[0]);
          router.push('/absences');
        }
      }).catch((error) => {
        this.data.errors = JSON.parse(JSON.stringify(error.response.data.errors));
        this.data.isRequested = false
      })
    },

     deleteFromStudent(data){
      this.data.form.students.splice(this.data.form.students.indexOf(data), 1);
    },

     getGroups(val){
         this.$baseApi.get('/absences/absences/' + this.$route.params.id + '/edit?option=group&i='+val.id).then((response)=>{
            if(response.data.code == 200){
               this.groups = response.data.data.groups;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },

      getLessons(val){
         this.$baseApi.get('/absences/absences/' + this.$route.params.id + '/edit?option=lesson&i='+val.id).then((response)=>{
            if(response.data.code == 200){
               this.lessons = response.data.data.lessons;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },

      getStudents(val){
         this.$baseApi.get('/absences/absences/' + this.$route.params.id + '/edit?option=student&i='+val.id).then((response)=>{
            if(response.data.code == 200){
               this.data.form.students = response.data.data.students;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },


     getTeachers(val){
      this.data.form.teacher_id = '';
      this.data.form.students   = [];
      this.isChanged = 1;
      if(this.user.role == 'teacher'){
        this.data.form.teacher_id = this.user.teacher_id;
        return;
      }
      this.getStudents(val);
      this.$baseApi.get('/absences/absences/' + this.$route.params.id + '/edit?l=' + val.id).then((response)=>{
            if(response.data.code == 200){
               this.teachers = response.data.data.teachers;
               if(this.user.role != 'teacher'){
                for (let index = 0; index < this.teachers.length; index++) {
                  this.data.form.teacher_id = this.teachers[index].id;   
                }
               }

            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
    },
      setReviewAyaVal($event, key){
         this.$baseApi.get('/absences/absences/' + this.$route.params.id + '/edit?sura=' + $event).then((response)=>{
            if(response.data.code == 200){

               this.data.form.students[key].reviewAyaFromOptions  = response.data.data.options;

            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },

       setReviewAyaToVal($event, key){
         this.$baseApi.get('/absences/absences/' + this.$route.params.id + '/edit?sura=' + $event).then((response)=>{
            if(response.data.code == 200){

               this.data.form.students[key].reviewAyaToOptions  = response.data.data.options;

            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
   
  loadOptions(search, key) {
    if(this.data.form.lesson_id == ''){
      this.sweetAlert('لا يمكنك اختيار طالب قبل اختيار الحلقة', 'warning');
      return;
    }
    if(search == ''){
      this.data.form.students[key].stOptions = [];
      return;
    }
      this.$baseApi.get('/absences/absences/' + this.$route.params.id + '/edit?student=' + search + '&lesson=' + this.data.form.lesson_id).then((response)=>{
            if(response.data.code == 200){

               this.data.form.students[key].stOptions  = response.data.data.options;

            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
  }
  },
  computed: {
    getErrors() {
      return JSON.parse(JSON.stringify(this.data.errors))
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    }
  },
  watch: {
    'data.form.date_and_time': function (newVal, oldVal){
         this.checkerExit();
     }
  }
};
</script>
<style>
.role-box {
  border-radius: 6px;
  box-shadow: 1px 1px 4px 0 #0000004a;
  padding: 11px;
}

.role-box h5 {
  text-align: center;
  border-bottom: 1px solid #8080808c;
}
.role-selected {
  border-radius: 6px;
  box-shadow: 0 2px 2px 0 #00000042;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding: 11px;
}
</style>
